/*
 * Favoris — stockage local, aucune application requise.
 *
 * Même principe que recently-viewed : les données restent dans le
 * navigateur du visiteur. Rien n'est envoyé à un serveur, donc aucune
 * donnée personnelle collectée et rien à déclarer côté RGPD. En
 * contrepartie, la liste ne suit pas le visiteur d'un appareil à l'autre :
 * c'est le compromis assumé d'une solution sans compte ni application.
 *
 * Les libellés viennent de #WishlistConfig, alimenté par Liquid : un .js
 * statique ne peut pas appeler le filtre | t.
 */
(function () {
  'use strict';

  var KEY = 'klina_wishlist';
  var MAX = 50;

  var cfg = {};
  try {
    var cfgEl = document.getElementById('WishlistConfig');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {}
  var STR = cfg.strings || {};

  function str(key) { return STR[key] || ''; }

  /* ---------- Stockage ---------- */

  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Object.prototype.toString.call(value) === '[object Array]' ? value : [];
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
    } catch (e) {}
  }

  function indexOf(items, handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].handle === handle) return i;
    }
    return -1;
  }

  /* ---------- Utilitaires ---------- */

  function esc(value) {
    var d = document.createElement('div');
    d.textContent = value == null ? '' : value;
    return d.innerHTML;
  }

  function plural(key, count) {
    var entry = STR[key];
    if (!entry) return '';
    var text = (typeof entry === 'string') ? entry : (count === 1 ? entry.one : entry.other);
    return String(text || '').replace('%%COUNT%%', count);
  }

  /* ---------- Rendu ---------- */

  function refreshBadge(items) {
    var count = items.length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].hidden = (count === 0);
    }
    var triggers = document.querySelectorAll('[data-wishlist-open]');
    for (var j = 0; j < triggers.length; j++) {
      triggers[j].setAttribute('aria-label',
        count > 0 ? plural('headerCount', count) : str('headerLabel'));
    }
  }

  function refreshToggles(items) {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var on = indexOf(items, btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-wishlist-label]');
      var text = on ? str('remove') : str('add');
      if (label) { label.textContent = text; }
      else { btn.setAttribute('aria-label', text); }
    }
  }

  function refreshList(items) {
    var list = document.querySelector('[data-wishlist-list]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var p = items[i];
      if (!p || !p.handle) continue;
      var removeLabel = String(str('removeFor') || '').replace('%%TITLE%%', p.title || '');
      html +=
        '<li class="wl-item">' +
          '<a class="wl-item-link" href="' + esc(p.url) + '">' +
            (p.image
              ? '<img class="wl-item-img" src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">'
              : '<span class="wl-item-img wl-item-img--empty"></span>') +
            '<span class="wl-item-body">' +
              '<span class="wl-item-title">' + esc(p.title) + '</span>' +
              '<span class="wl-item-price">' + esc(p.price) + '</span>' +
            '</span>' +
          '</a>' +
          '<button type="button" class="wl-item-remove" data-wishlist-remove="' + esc(p.handle) + '" ' +
                  'aria-label="' + esc(removeLabel) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
              '<line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/>' +
            '</svg>' +
          '</button>' +
        '</li>';
    }
    list.innerHTML = html;
  }

  function refresh() {
    var items = read();
    refreshBadge(items);
    refreshToggles(items);
    refreshList(items);
  }

  /* ---------- Actions ---------- */

  function announce(message) {
    var live = document.querySelector('[data-wishlist-status]');
    if (!live || !message) return;
    live.textContent = '';
    /* Vider puis réécrire : sans cela, deux ajouts successifs du même
       texte ne sont pas réannoncés par les lecteurs d'écran. */
    window.setTimeout(function () { live.textContent = message; }, 40);
  }

  function toggle(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;

    var items = read();
    var at = indexOf(items, handle);

    if (at !== -1) {
      items.splice(at, 1);
      save(items);
      refresh();
      announce(str('removed'));
      return;
    }

    items.unshift({
      handle: handle,
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || '',
      image: btn.getAttribute('data-image') || '',
      price: btn.getAttribute('data-price') || ''
    });
    save(items);
    refresh();
    announce(str('added'));
  }

  function remove(handle) {
    var items = read();
    var at = indexOf(items, handle);
    if (at === -1) return;
    items.splice(at, 1);
    save(items);
    refresh();
    announce(str('removed'));
  }

  /* ---------- Tiroir ---------- */

  var drawer = document.getElementById('wishlist-drawer');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    refresh();
    drawer.hidden = false;
    document.body.classList.add('wl-open');
    var close = drawer.querySelector('[data-wishlist-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('wl-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Événements ----------
     Délégation sur document : les lignes du tiroir et les cœurs des
     fiches produit sont créés après coup, un addEventListener posé au
     chargement les manquerait. */

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (toggleBtn) {
      e.preventDefault();
      toggle(toggleBtn);
      return;
    }

    var openBtn = e.target.closest ? e.target.closest('[data-wishlist-open]') : null;
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeBtn = e.target.closest ? e.target.closest('[data-wishlist-close]') : null;
    if (closeBtn) {
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest ? e.target.closest('[data-wishlist-remove]') : null;
    if (removeBtn) {
      remove(removeBtn.getAttribute('data-wishlist-remove'));
      return;
    }

    if (drawer && !drawer.hidden && e.target === drawer) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Un autre onglet a modifié la liste : on se resynchronise. */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refresh();
  });

  refresh();
})();
